module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData", "$cookies", "$http",
        function (Service, $q, brand, brandConfig, session, sessionData, $cookies, $httpProvider) {

            new Service({
                name: 'groupContracts',
                group:"eprsvc",
                url: "/eprsvc/x-services/secure/documents/v1/group-contracts-with-riders",
                headers: {},
                cache: false,
                submitSearch: function(theLid) {
                    this.headers['APPID'] = "EPRWEB";
                    this.headers['clientHost'] = "hmhs.com";
                    if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                        this.headers['ClientNumber']  = sessionData.clientNumber;
                    }
                    return this.get();
                }
            });
        }]);
};
